module.exports = __webpack_public_path__ + "static/media/west-vesey.30176dab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/west-vesey.svg
// module id = 81
// module chunks = 0